/**
 * @generated SignedSource<<a79f266ce776cb07148c38ed733b2659>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedMarketTrendsPriceStats_creatorMarketTrends$data = {
  readonly priceStats: {
    readonly avgSalePrice: {
      readonly " $fragmentSpreads": FragmentRefs<"currencyHelpers_financialAmount">;
    } | null;
    readonly itemsSold: number | null;
    readonly priceRange: {
      readonly high: {
        readonly " $fragmentSpreads": FragmentRefs<"currencyHelpers_financialAmount">;
      } | null;
      readonly low: {
        readonly " $fragmentSpreads": FragmentRefs<"currencyHelpers_financialAmount">;
      } | null;
    } | null;
    readonly valueChange: number | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedMarketTrendsIconicDesigns_creatorMarketTrends">;
  readonly " $fragmentType": "SbSharedMarketTrendsPriceStats_creatorMarketTrends";
};
export type SbSharedMarketTrendsPriceStats_creatorMarketTrends$key = {
  readonly " $data"?: SbSharedMarketTrendsPriceStats_creatorMarketTrends$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedMarketTrendsPriceStats_creatorMarketTrends">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "InlineDataFragmentSpread",
    "name": "currencyHelpers_financialAmount",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "kind": "LinkedField",
        "name": "convertedAmountList",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currency",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "args": null,
    "argumentDefinitions": ([]/*: any*/)
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedMarketTrendsPriceStats_creatorMarketTrends",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedMarketTrendsIconicDesigns_creatorMarketTrends"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MarketTrendsPriceStats",
      "kind": "LinkedField",
      "name": "priceStats",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemsSold",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "valueChange",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "avgSalePrice",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MarketTrendsPriceRange",
          "kind": "LinkedField",
          "name": "priceRange",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "low",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "high",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MarketTrendsConnection",
  "abstractKey": null
};
})();

(node as any).hash = "0d1322344eda30aa0c5ef55ec7a38aa9";

export default node;
